import css from '@emotion/css/macro';
import {includes} from 'lodash';
import React from 'react';
import {FieldArray} from 'react-final-form-arrays';
import {Checkbox} from 'semantic-ui-react';

const toggle = (fields, checked, option) => {
  const index = (fields.value || []).findIndex((x) => x === option);
  if (checked) {
    fields.push(option);
  } else if (index > -1) {
    fields.remove(index);
  }
};

type MultiSelectCheckbox = {
  fieldName: string;
  options: string[];
  fieldLabel?: string;
  disabled?: boolean;
};

export const MultiSelectCheckbox: React.FC<MultiSelectCheckbox> = ({
  fieldName,
  options,
  fieldLabel,
  disabled = false,
}) => {
  return (
    <FieldArray
      name={fieldName}
      options={options}
      render={(props) => (
        <div className="form-field" css={styles}>
          <label>{fieldLabel}</label>

          {options.map((option) => (
            <div className="inline-label" key={option}>
              <Checkbox
                type="checkbox"
                id={`${props.fields.name}_${option}`}
                checked={includes(props.fields.value, option)}
                onChange={(event, {checked}) =>
                  toggle(props.fields, checked, option)
                }
                disabled={disabled}
              />
              <label htmlFor={`${props.fields.name}_${option}`}>{option}</label>
            </div>
          ))}
        </div>
      )}
    />
  );
};

const styles = css`
  > label {
    display: block;
    margin: 0em 0em 0.28571429rem 0em;
    font-size: 0.92857143em;
    color: #444;
    font-weight: bold;
    display: block;
  }

  .inline-label {
    display: flex;
    align-items: center;
    margin-bottom: 0.3rem;

    > label {
      flex: 1 1 0%;
      padding-left: 0.3rem;
      margin-left: 0.3rem;

      &:hover {
        cursor: pointer;
        background: #efefef;
        border-radius: 2px;
      }
    }
  }
`;
